(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbs-seller-intake"] && !Shopify.designMode) return;
  try {
    

(function (root) {
  'use strict';
  const MAX_SOURCE_BYTES = 20 * 1024 * 1024;
  const MAX_UPLOAD_BYTES = 1.5 * 1024 * 1024;
  const TYPES = ['image/jpeg', 'image/png', 'image/webp'];
  function validate(file) {
    if (!file || !file.size) throw new Error('Choose a photograph that is not empty.');
    if (file.size > MAX_SOURCE_BYTES) throw new Error('Each original photo can be up to 20 MB. Choose a smaller photo or export a smaller copy.');
    if (!TYPES.includes(file.type) && !(file.type === '' && /\.(jpe?g|png|webp)$/i.test(file.name || ''))) {
      throw new Error(/hei[cf]/i.test(file.type + ' ' + file.name) ? 'This photo is in HEIC format. Export or share it as a JPEG, or upload a screenshot instead.' : 'Choose JPEG, PNG or WebP photos, up to 20 MB each.');
    }
  }
  async function prepare(file) {
    validate(file);
    const url = URL.createObjectURL(file);
    const image = new Image();
    let timer;
    let canvas;
    try {
      await new Promise((resolve, reject) => {
        timer = setTimeout(() => reject(new Error('This photo took too long to open. Export a smaller JPEG copy and try again.')), 30000);
        image.onload = resolve;
        image.onerror = () => reject(new Error('This photo could not be opened. Export a JPEG copy or choose another photo.'));
        image.src = url;
      });
      clearTimeout(timer);
      if (!image.naturalWidth || !image.naturalHeight || image.naturalWidth * image.naturalHeight > 60_000_000) {
        throw new Error('This photo has an unsupported resolution. Export a smaller JPEG copy and try again.');
      }
      const ratio = Math.min(1, 2000 / Math.max(image.naturalWidth, image.naturalHeight));
      canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(image.naturalWidth * ratio));
      canvas.height = Math.max(1, Math.round(image.naturalHeight * ratio));
      const context = canvas.getContext('2d');
      if (!context) throw new Error('Your browser could not prepare this photo. Try a smaller JPEG photo.');
      context.fillStyle = '#fff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      const encode = quality => new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('This photo could not be prepared. Choose another JPEG photo.')), 'image/jpeg', quality));
      let blob = await encode(0.9);
      if (blob.size > MAX_UPLOAD_BYTES) blob = await encode(0.7);
      if (blob.size > MAX_UPLOAD_BYTES) throw new Error('This photo is still too large after resizing. Please choose a smaller JPEG copy.');
      return new File([blob], 'item-photo.jpg', { type: 'image/jpeg' });
    } finally {
      clearTimeout(timer);
      image.onload = null;
      image.onerror = null;
      image.src = '';
      URL.revokeObjectURL(url);
      if (canvas) { canvas.width = 1; canvas.height = 1; }
    }
  }
  root.TBSUploadPhotos = Object.freeze({ validate, prepare, maxSourceBytes: MAX_SOURCE_BYTES });
})(window);

(() => {
  async function send(url, options, timeout) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);
    try { return await fetch(url, { ...options, signal: controller.signal }); }
    finally { clearTimeout(timer); }
  }
  const bind = () => document.querySelectorAll('[data-seller-form]').forEach(form => {
    if (form.dataset.bound) return;
    form.dataset.bound = 'true';
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[role="status"]');
    const originalLabel = button.textContent;
    let key;
    let hasSent = false;
    try { key = btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(32)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
    catch { status.textContent = 'Please open this page in an updated browser to submit securely.'; return; }
    status.tabIndex = -1;
    status.setAttribute('aria-atomic', 'true');
    function message(text, state, reveal = false) {
      status.textContent = text;
      status.dataset.state = state;
      status.setAttribute('role', state === 'error' ? 'alert' : 'status');
      if (reveal) { status.scrollIntoView({ behavior: 'smooth', block: 'center' }); status.focus({ preventScroll: true }); }
    }
    function received() {
      message(form.dataset.success, 'success', true);
      button.textContent = 'Submission received';
      button.disabled = true;
      form.querySelectorAll('input,select,textarea').forEach(input => input.disabled = true);
    }
    async function receipt() {
      const response = await send(form.action + '/receipt', { credentials: 'omit', cache: 'no-store', headers: { 'X-Intake-Submission-Key': key } }, 20000);
      if (!response.ok) throw new Error('The confirmation check is unavailable. Your details have been kept. Please contact sell@thebuyshop.la before submitting this item again.');
      const result = await response.json();
      if (typeof result.received !== 'boolean') throw new Error(form.dataset.error);
      return result.received;
    }
    button.disabled = false;
    form.addEventListener('invalid', () => message('Please complete the highlighted required field.', 'error'), true);
    form.addEventListener('change', event => {
      if (event.target.type !== 'file' || !window.TBSUploadPhotos) return;
      try { for (const file of event.target.files) window.TBSUploadPhotos.validate(file); event.target.removeAttribute('aria-invalid'); }
      catch (error) { event.target.setAttribute('aria-invalid', 'true'); message(error.message, 'error', true); }
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (form.dataset.busy || !form.reportValidity()) return;
      form.dataset.busy = 'true';
      button.disabled = true;
      try {
        if (hasSent) { message('Checking whether your item was already received…', 'sending', true); if (await receipt()) { received(); return; } }
        if (!window.TBSUploadPhotos) throw new Error('The photo uploader did not finish loading. Refresh this page and try again.');
        const inputs = [...form.querySelectorAll('[type="file"]')];
        const chosen = inputs.filter(input => input.files.length);
        if (!chosen.length || chosen.length > 10) throw new Error('Upload a front photo and up to nine optional photos.');
        const data = new FormData(form);
        for (const input of inputs) data.delete(input.name);
        let total = 0;
        button.textContent = 'Preparing photographs…';
        for (let index = 0; index < chosen.length; index++) {
          message('Preparing photograph ' + (index + 1) + ' of ' + chosen.length + '…', 'sending', index === 0);
          const prepared = await window.TBSUploadPhotos.prepare(chosen[index].files[0]);
          total += prepared.size;
          if (total > 20 * 1024 * 1024) throw new Error('The photos are too large together. Choose smaller photos and try again. Your details have been kept.');
          data.append(chosen[index].name, prepared, prepared.name);
        }
        const tokenResponse = await send(form.action + '/token', { credentials: 'omit', cache: 'no-store' }, 20000);
        if (!tokenResponse.ok) throw new Error(tokenResponse.status === 429 ? 'Too many attempts. Please wait a few minutes and try again.' : 'A secure connection could not be started. Your details have been kept. Please try again.');
        const session = await tokenResponse.json();
        if (!/^[A-Za-z0-9_-]{43}$/.test(session.token || '')) throw new Error('A secure connection could not be started. Please try again.');
        button.textContent = 'Sending your submission…';
        message(form.dataset.sending, 'sending');
        hasSent = true;
        const response = await send(form.action, { method: 'POST', credentials: 'omit', headers: { 'X-Intake-Token': session.token, 'X-Intake-Submission-Key': key }, body: data }, 90000);
        let result;
        try { result = await response.json(); } catch { result = {}; }
        if (!response.ok) {
          if (response.status === 413) throw new Error('The upload was too large. Choose smaller photographs and try again. Your details have been kept.');
          if (response.status === 429) throw new Error('Too many attempts. Please wait a few minutes and try again.');
          if (response.status === 403) throw new Error('Your secure upload session expired. Your details have been kept. Please try again.');
          throw new Error([400,409].includes(response.status) && typeof result.error === 'string' ? result.error.slice(0,500) : form.dataset.error);
        }
        if (result.received !== true) throw new Error(form.dataset.error);
        received();
      } catch (error) {
        if (hasSent) {
          try { if (await receipt()) { received(); return; } }
          catch { message('We could not confirm receipt. Your details and photos have been kept. Please contact sell@thebuyshop.la before submitting this item again.', 'error', true); delete form.dataset.busy; button.disabled = false; button.textContent = 'Check submission & retry'; return; }
        }
        const network = error.name === 'AbortError' || error instanceof TypeError;
        message(network ? 'The connection was interrupted. Your details and photos have been kept. Use the button to check and try again.' : error.message || form.dataset.error, 'error', true);
        delete form.dataset.busy;
        button.disabled = false;
        button.textContent = hasSent ? 'Check submission & retry' : originalLabel;
      }
    });
  });
  bind();
  document.addEventListener('shopify:section:load', bind);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbs-seller-test-oct15"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = () => document.querySelectorAll('[data-seller-test-form]').forEach(form => {
    if (form.dataset.bound) return;
    form.dataset.bound = 'true';
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[role="status"]');
    button.disabled = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (form.dataset.busy || !form.reportValidity()) return;
      const files = [...form.querySelectorAll('[type="file"]')].flatMap(input => [...input.files]);
      if (files.some(file => file.size > 5 * 1024 * 1024 || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type))) {
        status.textContent = form.dataset.photoError;
        return;
      }
      form.dataset.busy = 'true';
      button.disabled = true;
      status.textContent = form.dataset.sending;
      try {
        const endpoint = form.action;
        const tokenResponse = await fetch(endpoint + '/token', { credentials: 'omit', cache: 'no-store' });
        if (!tokenResponse.ok) throw new Error('connection');
        const session = await tokenResponse.json();
        const data = new FormData(form);
        for (const [name, value] of [...data]) {
          if (value instanceof File && !value.name) data.delete(name);
        }
        const response = await fetch(endpoint, {
          method: 'POST', credentials: 'omit', headers: { 'X-Intake-Token': session.token }, body: data
        });
        if (!response.ok) throw new Error('submission');
        status.textContent = form.dataset.success;
        form.querySelectorAll('input,select,textarea').forEach(input => input.disabled = true);
      } catch {
        status.textContent = form.dataset.error;
        delete form.dataset.busy;
        button.disabled = false;
      }
    });
  });
  bind();
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-tbs-video-toggle]');
  if (!button) return;
  const video = button.closest('.banner').querySelector('video');
  if (!video) return;
  if (video.paused) {
    video.play().then(function() {
      button.textContent = button.dataset.pause;
      button.setAttribute('aria-pressed', 'false');
    }).catch(function() {});
  } else {
    video.pause();
    button.textContent = button.dataset.play;
    button.setAttribute('aria-pressed', 'true');
  }
});

  } catch(e) { console.error(e); }
})();
})();
